<template>

    <v-card>
        <v-card-title>Sites Importer</v-card-title>

        <v-divider></v-divider>

        <v-card-text>

            <div class="content-area" style="min-height: 220px;">

                <div class="initial-state" v-if="!importFile">
                    <div>
                        <v-icon large class="download-file-icon">mdi-microsoft-excel</v-icon>
                        <span class="download-file-text" @click="downloadExcelImporter">
                            Download Excel Importer
                        </span>
                    </div>

                    <vue-dropzone ref="myVueDropzone" id="file-dropzone" :class="{'drag-active': dragActive}" :options="dropzoneOptions" :useCustomSlot=true @vdropzone-file-added="handler" 
                        @vdropzone-drag-enter="dragActive = true" @vdropzone-drag-over="dragActive = true" @vdropzone-drag-leave="dragActive = false" :include-styling="false">
                        <div class="dropzone-custom-content">
                            <h3 class="title">Drag and drop to import sites file</h3>
                            <div class="subtitle">or click to select the file from your computer</div>
                        </div>
                    </vue-dropzone>

                    <span class="file-error" v-if="error">{{error}}</span>
                </div>

                <div class="confirm-state" v-if="importFile && !importingData && !importingSuccess && !importingFailure">
                    <span class="text">Are you sure you want to import this file? This will overwrite all site data!</span>
                    <v-btn color="#c42111" class="mt-4" @click="importData">
                        <v-icon class="mr-3">mdi-database-import</v-icon>
                        Import Data
                    </v-btn>
                </div>

                <div class="importing-state" v-if="importFile && importingData">
                    <span class="importing-title">Importing Sites</span>
                    <v-progress-linear color="light-blue" height="10" indeterminate striped></v-progress-linear>
                </div>

                <div class="importing-state" v-if="importFile && importingSuccess">
                    <span class="success-title">Sites Import Success!</span>
                    <span class="success-info">{{ `Sites Added: ${successObj.new_count}` }}</span>
                    <span class="success-info">{{ `Sites Updated: ${successObj.edit_count}` }}</span>
                </div>

                <div class="importing-state" v-if="importFile && importingFailure">
                    <v-icon color="#ff5252" x-large>mdi-close-circle</v-icon>
                    <span class="failure">{{ failureText }}</span>
                </div>

            </div>

        </v-card-text>

        <v-divider />

        <v-card-actions v-if="!importingData">
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('cancel')" v-if="!importingSuccess && !importingFailure">Cancel</v-btn>
            <v-btn text @click="$emit('finished')" v-if="importingSuccess || importingFailure">Ok</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
export default {
    name: 'SitesImporter',
    props: [],
    components: {
        vueDropzone: vue2Dropzone
    },
    data: () => ({
        maxFileSizeBytes: 52430000, // actually 50MB
        dropzoneOptions: {
            url: (TELSA.apiHost + "sitebook/files/upload"),
            thumbnailWidth: 150,
            maxFilesize: 9999999999,
            parallelUploads: 6,
            autoQueue: false,
            createImageThumbnails: false,
            previewTemplate: '<div></div>',
        },
        dragActive: false,
        error: '',
        importFile: null,
        importingData: false,
        importingSuccess: false,
        importingFailure: false,
        failureText: '',
        successObj: null
    }),

    computed: {
    },

    methods: {        
        downloadExcelImporter: function() {
            let route = `${TELSA.apiHost}sites/importer`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                let dlink = document.createElement('a');
                dlink.setAttribute("id", "screenshot-download-file-link-hidden");
                dlink.href = result;
                dlink.download = "TelsasoftSitesImporter.xlsx";
                dlink.click();
                dlink.remove();
                TELSA.loading(false);
            });
        },

        handler: function(file) {
            this.dragActive = false;
            // Check if file breaks any rules
            if(file.size > this.maxFileSizeBytes) {
                // File too big
                this.error = `File size exceeds maximum size of ${TELSA.readableFileSize(this.maxFileSizeBytes)}.`;
                return;
            }
            if(file.name.split('.').pop() != 'xlsx') {
                // Wrong file type
                this.error = `Invalid File`;
                return;
            }
            this.error = '';

            let fileObj = {
                name: file.name,
                type: file.type,
                size: file.size,
                data: ''
            };
            let self = this;
            let reader = new FileReader();
            reader.onload = function (e) {
                //self.attachments.push(fileObj);
                console.log(fileObj);
                fileObj.data = e.target.result;
                self.importFile = fileObj;
            }
            reader.readAsDataURL(file);
        },

        importData: function() {
            this.importingData = true;
            let route = `${TELSA.apiHost}sites/importer`;
            return this.$http.post(route, {args: {lock: this.$store.state.lock, file: this.importFile}}).then(response => {
                let result = response.body;
                this.importingData = false;
                if(result.success) {
                    this.successObj = result.success;
                    this.importingSuccess = true;
                }
                else {
                    this.importingFailure = true;
                    this.failureText = result;
                }
            }, error => {
                this.importingData = false;
                this.$emit('cancel');
            });
        }
    },

    created() {
    },

    mounted() {
    },

};
</script>

<style scoped>

    #file-dropzone {
        margin: 2em auto;
        width: 100%;
        max-width: 1000px;
        border: #000000 solid 1px;
        text-align: center;
        padding: 2em;
        cursor: pointer;
        background-color: rgba(48,48,48,0.75);
    }

    #file-dropzone.drag-active {
        border: #4caf50 solid 1px;
        background-color: rgba(48,48,48,0.5);
    }

    .file-error {
        animation: shake-horizontal 0.3s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
        color: #ff5252;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        display: block;
        margin-top: -1em;
    }

    #file-dropzone .title {
        color: #ffffff;
        font-size: 1.25rem !important;
        font-weight: 500;
        line-height: 2rem;
        letter-spacing: 0.0125em !important;
        font-family: "Roboto", sans-serif !important;
    }
    #file-dropzone .subtitle {
        color: #ffffff;
    }

    .download-file-icon {
        color: #7EB900;
        display: inline-block;
    }
    .download-file-text {
        font-size: 22px;
        text-decoration: underline;
        cursor: pointer;
        margin-top: 1em;
        vertical-align: sub;
        display: inline-block;
        width: auto;
    }

    .confirm-state {
        text-align: center;
    }
    .confirm-state .text {
        display: block;
        padding-top: 2em;
        font-size: 18px;
        color: #ffffff;
        font-weight: bold;
        text-align: center;
    }

    .importing-state {
        padding-top: 5em;
        text-align: center;
    }

    .importing-state .importing-title {
        font-size: 26px;
        display: block;
        color: #ffffff;
        padding-bottom: 1em;
    }

    .importing-state .success-title {
        display: block;
        font-size: 26px;
        color: #4caf50;
        font-weight: bold;
        padding-bottom: 1em;
    }

    .importing-state .success-info {
        display: block;
        font-size: 18px;
    }

    .importing-state .failure {
        color: #ff5252;
        display: block;
    }
    
</style>

